module.exports = __webpack_public_path__ + "static/media/YouTube.f907e912.svg";